import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { IncomingInvoiceList } from "@msuite/utils/types";
import { client } from "@/hono";
import { useCitadel } from "@/hooks/use-citadel";

export function useIncomingInvoices() {
	/** Hooks */
	const { citadel } = useCitadel();

	/** Query */
	// The navigation entry is already behind `read IncomingInvoice`, so a caller without it arrives
	// here only by typing the address; the query waits for the rule rather than toasting a 403.
	const query = useQuery({
		queryKey: ["incoming-invoices"],
		enabled: citadel?.can("read", "IncomingInvoice") === true,
		queryFn: async () => {
			const response = await client.incoming_invoices.index.$get();
			const data = await responseHandler(response);
			return data.incomingInvoices as IncomingInvoiceList;
		},
	});

	/** Return */
	return { ...query, incomingInvoices: query.data ?? [] };
}
